import RadioButton, { RadioButtonProps } from './RadioButton';

export type { RadioButtonProps };
export default RadioButton;
